<template>
  <!-- 保单管理 -->
  <div class="insuredOrder main-container">
    <div class="content">
      <div class="search-box btn3">
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" :transfer="true" filterable clearable>
            <Option v-for="(item, i) in companyList" :key="i" :value="item.code">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">录单时间</span>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :value="searchParams.date"
            @on-change="searchParams.date = $event"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">录单人员</span>
          <Select v-model="searchParams.enterUserId" :transfer="true" clearable filterable>
            <Option v-for="(item, i) in sysUserList" :key="i" :value="item.id">{{ item.userName }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">备注</span>
          <Input v-model="searchParams.remark" placeholder="请输入关键词" clearable />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>

      <div class="sedTab" v-if="isShowSed">
        <ul class="filterTab">
          <li :class="{ active: curActive == index }" v-for="(item, index) in sendTab" :key="index" @click="toggleSecondTab(index, item)">
            {{ item.label }}
          </li>
        </ul>
      </div>
      <div class="tipBox clearfix">
        <div class="left clearfix" v-if="$units.superviseShowVal()">
          <div v-if="$units.pointAction('order_30_6')">
            <Checkbox v-model="isAll" @on-change="handleCheckAll"></Checkbox>
            已选
            <span class="total">{{ isAll ? total : checkItemsList.length }}</span>
            单， 共
            <span class="total">{{ total }}</span
            >单
          </div>
          <div v-else>
            共<span class="total">{{ total }}</span
            >单
          </div>
          <div v-if="!hiddenTxt">
            已支付保费：
            <span class="other">{{ countObj.payedAmount || '0.00' }}</span
            >元
          </div>
          <div v-if="!hiddenTxt">
            已支付标保：
            <span class="other">{{ countObj.payedFoldFyb || '0.00' }}</span
            >元
          </div>

          <div>
            退款保费：
            <span class="other">{{ countObj.refundedAmount || '0.00' }}</span
            >元
          </div>
          <div>
            退款标保：
            <span class="other">{{ countObj.refundedFoldFyb || '0.00' }}</span
            >元
          </div>
        </div>
        <Button
          type="primary"
          class="right"
          ghost
          @click="$refs.daochuModal.open(searchParams, 'isAbnormal')"
          v-if="$units.pointAction('order_30_4') && $units.superviseShowVal()"
          >导出</Button
        >
        <Button type="primary" class="right-del" ghost v-if="$units.pointAction('order_30_6')" @click="batchDelete">批量删除</Button>
      </div>
      <loading :isShow="listLoading" />
      <div class="tableBox setTable" v-if="listLoading || insureList.length">
        <div class="tableHead">
          <Checkbox class="page-check" v-if="$units.pointAction('order_30_6')" v-model="isCheckPage" :disabled="isAll" @on-change="handleCheckPage"></Checkbox>
          <div class="item name left">业务类别/产品/险种名称</div>
          <div class="item name">保费（元）</div>
          <div class="item name">公司标保（元）</div>
          <div class="item name" v-if="$units.pointAction('order_30_9')">
            服务费（元）
            <Poptip trigger="hover" v-if="userInfo.userType != 4">
              <Icon type="ios-help-circle-outline" size="18" color="#fff" style="margin-left: -6px; margin-top: 2px" />
              <div slot="content" style="color: #333">当前机构服务费，包含给下级机构和业务员的服务费</div>
            </Poptip>
          </div>
          <div class="item name1">保单/险种状态</div>
          <div class="item name">回执回访状态</div>
          <div class="item name">出单业务员</div>
          <div class="item action" ref="operation">操作</div>
        </div>
        <div class="items" v-for="item in insureList" :key="item.id">
          <div class="tableTip">
            <!-- <div class="anomaly">异常单</div> -->
            <Checkbox
              v-if="$units.pointAction('order_30_6')"
              v-model="item._checked"
              :disabled="item._disabled"
              @on-change="handleCheckItem($event, item)"
            ></Checkbox>
            <div class="item">
              <span>承保时间:</span>
              <span v-if="item.insureTime">{{ item.insureTime | filterTime('YYYY-MM-DD') }}</span>
              <span v-else class="red">缺失</span>
            </div>
            <div class="item">
              <span>保单号:</span>
              <span>{{ item.policyNo }}</span>
            </div>
            <div class="item">
              <span>投/被保险人:</span>
              <span v-if="item.holderName || item.insuranceName">{{ item.holderName }}/{{ item.insuranceName }}</span>
              <span v-else class="red">缺失</span>
            </div>
            <div class="item">
              <span>手机号:</span>
              <span v-if="item.holderMobile">{{ item.holderMobile }}</span>
              <span v-else class="red">缺失</span>
            </div>
            <div class="item last">
              <span>所属团队:</span>
              <span v-if="item.groupName">{{ item.orgName }}/{{ item.groupName }}</span>
              <div v-else-if="item.orgName">{{ item.orgName }}/<span class="red">缺失</span></div>
              <span v-else class="red">缺失</span>
            </div>
            <div class="item" v-if="item.source">
              <span>产品来源:</span>
              <span>{{ item.source }}</span>
            </div>
          </div>
          <div class="tBody" :class="{ 'p-b': item.hasAdditional }">
            <div class="top">
              <div class="item name left">
                <span class="sellTypeColumn" v-if="item.sellTypes">
                  <Tag color="blue" v-if="item.sellTypes.includes('1')">网销</Tag>
                  <Tag color="blue" v-if="item.sellTypes.includes('2')">电销</Tag>
                  <Tag color="blue" v-if="item.sellTypes.includes('3')">经代</Tag>
                </span>
                <span v-else>-</span>
                {{ item.productName }}({{ item.productCode }})
              </div>
              <div class="item name">{{ item.fee }}</div>
              <div class="item name">{{ item.foldFyb }}</div>
              <div class="item name" v-if="$units.pointAction('order_30_9')">
                <span v-if="item.noCommissionReason && !item.hasAdditional" class="red">{{ item.noCommissionReason }}</span>
                <span v-else>{{ item.totalCommission }}</span>
              </div>
              <div class="item name1">
                {{ item.status | dealStatus }}
              </div>
              <div class="item name">
                <span v-if="item.receiptStatus || item.verifyStatus">{{ showReceiptRevisit(item) }}</span>
              </div>
              <div class="item name">
                <span v-if="item.salesmanName">{{ item.salesmanName }}</span>
                <span v-else class="red">缺失</span>
              </div>
              <div class="item action"></div>
            </div>
            <div class="main" v-if="item.hasAdditional">
              <div class="item name">
                {{ item.mainProductName }}
              </div>
              <div class="item name">{{ item.mainFee }}</div>
              <div class="item name">{{ item.mainFoldFyb }}</div>
              <div class="item name" v-if="$units.pointAction('order_30_9')">
                <span v-if="item.noCommissionReason" class="red">{{ item.noCommissionReason }}</span>
                <span v-else>{{ item.commission }}</span>
              </div>
              <div class="item name1">{{ item.status | dealStatus }}</div>
              <div class="item name"></div>
              <div class="item name1"></div>
              <div class="item name"></div>
              <div class="item action"></div>
            </div>
            <div class="other" v-if="item.hasAdditional">
              <div class="list" v-for="(items, indexs) in item.policyAdditionalList" :key="indexs">
                <div
                  class="item name"
                  :class="{ 'name1': its.key === 'settlementStatus' || its.key === 'status', 'action': its.key === 'action' }"
                  v-for="(its, idx) in policyAdditionalList"
                  :key="idx"
                >
                  <span v-if="idx == 2">{{ items.foldFyb }}</span>
                  <span v-else-if="its.key === 'commission' && $units.pointAction('order_30_9')">
                    <span v-if="items.noCommissionReason" class="red">{{ items.noCommissionReason }}</span>
                    <span v-else>{{ items[its.key] }}</span>
                  </span>
                  <span v-else-if="its.key === 'status'">{{ items[its.key] | dealStatus }}</span>
                  <span v-else>{{ items[its.key] }}</span>
                </div>
              </div>
            </div>

            <div class="bar-action" :class="{ 'no-add-insurance': !item.hasAdditional }">
              <a class="actionStyle" @click="handlerPolicyDetail(item, 'isAbnormal')">详情</a>
              <a class="actionStyle" v-if="$units.pointAction('order_30_2')" @click="modifyPolicy('edit', item)">编辑</a>
              <a class="actionStyle" v-if="$units.pointAction('order_30_6')" @click="modifyPolicy('delete', item)">删除</a>
            </div>
          </div>
        </div>
      </div>
      <no-data v-else></no-data>
      <div class="pageBox" v-if="insureList.length">
        <Page :total="total" :current="searchParams.pageNo" :page-size="searchParams.pageSize" show-total @on-change="pageChange" style="text-align: center" />
      </div>
    </div>

    <!-- 线下保单详情 -->
    <policyDetail ref="policyDetailRef" :policyType="'anomaly'"></policyDetail>
    <!-- 线上保单详情  -->
    <detailModal ref="detailModal" :policyType="'anomaly'"></detailModal>
    <!-- 电子保单地址 -->
    <a ref="policyNoBox" :href="policyNo" target="_black"></a>
    <!-- 下载全部电子保单  -->
    <Modal v-model="showDownloadAll" title="下载全部电子保单" @on-ok="confirmEmail" width="500" :loading="$root.$children[0].modalLoading">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
        <FormItem prop="email" label="邮箱">
          <Input v-model="formValidate.email" placeholder="请输入您的电子邮箱" />
        </FormItem>
      </Form>
    </Modal>
    <!-- 导出保单  -->
    <daochu-modal ref="daochuModal"></daochu-modal>
    <!-- 导入保单  -->
    <import-modal ref="importModal" code="abnormalPolicy" title="批量导入异常单"></import-modal>
  </div>
</template>

<script>
import lzDicSelect from "@/components/commons/lzDicSelect";
import detailModal from "./components/detailModal";
import policyDetail from "./components/policyDetail";
import daochuModal from "./components/daochuModal";
import importModal from "./components/importConfig/importModal";
import myForm from "@/components/commons/form";
import { mapState } from "vuex";
import { pageTool, common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
export default {
  mixins: [pageTool, common],
  components: {
    daochuModal,
    selectTree,
    importModal,
    detailModal,
    myForm,
    policyDetail,
    lzDicSelect
  },
  props: ['show'],
  data() {
    return {
      formValidate: {
        email: ''
      },
      ruleValidate: {
        email: [
          {
            required: true,
            message: '请输入验证码'
          },
          {
            pattern: /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
            message: '请输入正确的邮箱'
          }
        ]
      },
      showDownloadAll: false,
      hiddenTxt: false,
      policyNo: '',
      detailInfo: {},
      sendTab: [],
      tab: '',
      companyList: [],
      isShowSed: false,
      curActive: 0,
      policyAdditionalList: [
        {
          key: 'name',
          name: '产品/险种名称'
        },
        {
          key: 'fee',
          name: '保费（元）'
        },
        {
          key: 'mainFoldFyb',
          name: '公司标保（元）'
        },
        {
          key: 'commission',
          name: '服务费（元）'
        },
        {
          key: 'status',
          name: '保单/险种状态'
        },
        {
          key: '',
          name: ''
        },
        {
          key: 'settlementStatus',
          name: ''
        },
        {
          key: '',
          name: ''
        },
        {
          key: 'action',
          name: ''
        }
      ],
      sendTabbase: [
        {
          label: '全部',
          value: '1'
        },
        {
          label: '未生效',
          value: '2'
        },
        {
          label: '已生效未过犹',
          value: '3'
        },
        {
          label: '部分退保',
          value: '4'
        },
        {
          label: '已过犹',
          value: '5'
        }
      ],
      sendTabother: [
        {
          label: '全部',
          value: '1'
        },
        {
          label: '犹内退保',
          value: '6'
        },
        {
          label: '犹外退保',
          value: '7'
        }
      ],
      countObj: {}, //统计数据
      searchParams: {
        isAbnormal: '1',
        applyOrgId: '',
        isSelfHold: '',
        isMutualHold: '',
        userType: '1',
        selectType: '1',
        pageNo: 1,
        pageSize: 5
      },
      insureList: [],
      total: 0,
      showOrderdetail: false,
      //表单搜索字段
      searchForm: [],
      columns: [],
      sysUserList: [],
      draftCount: 0,
      isAll: false,
      checkAllGroup: [],
      isCheckPage: false,
      RECEIPT_STATUS: JSON.parse(localStorage.getItem('dic')).RECEIPT_STATUS, //回执状态
      VERIFY_STATUS: JSON.parse(localStorage.getItem('dic')).VERIFY_STATUS, //回访状态
      checkItemsList: []
    };
  },
  watch: {
    payStatus(value) {
      if (value == 1) {
        this.sendTab = _.cloneDeep(this.sendTabbase);
        this.isShowSed = true;
        this.hiddenTxt = false;
      } else if (value == -1) {
        //已退保
        this.hiddenTxt = true;
        this.sendTab = _.cloneDeep(this.sendTabother);
        this.isShowSed = true;
      } else {
        this.isShowSed = false;
        this.hiddenTxt = false;
      }
      this.curActive = 0;
      this.searchParams.secondTab = ''; //复位二级tab
      this.getInsureList();
    },
    show: {
      handler(newVal) {
        if (!newVal) {
          this.$refs.importModal.visibleSmall = false;
        } else {
          this.$refs.importModal.visibleSmall = true;
        }
      }
    },
    immediate: true
  },
  computed: {
    ...mapState(['userInfo']),
    payStatus() {
      return this.searchParams.status;
    }
  },
  filters: {
    //保单险种状态
    dealStatus(val) {
      const m = new Map([
        ['1', '已承保'],
        ['-1', '已退保'],
        ['0', '已终止']
      ]);
      return m.get(val + '');
    },
    //回访状态
    dealVerifyStatus(val) {
      const m = new Map([
        ['0', '等待回访'],
        ['1', '回访成功'],
        ['2', '回访失败'],
        ['3', '无需回访']
      ]);
      return m.get(val + '');
    }
  },
  methods: {
    showReceiptRevisit(item) {
      if (item.receiptStatus && item.verifyStatus) {
        return this.RECEIPT_STATUS[item.receiptStatus] + this.VERIFY_STATUS[item.verifyStatus];
      } else if (item.receiptStatus) {
        return this.RECEIPT_STATUS[item.receiptStatus];
      } else if (item.verifyStatus) {
        return this.VERIFY_STATUS[item.verifyStatus];
      } else {
        return '无数据';
      }
    },
    // 获取录单人
    getSysUserList() {
      this.$http({
        url: `/buz/policy/sysUserList`,
        type: 'POST',
        data: {}
      }).then(res => {
        this.sysUserList = res.data;
      });
    },
    // 切换tab重新调用导入接口
    getImport() {
      // this.$refs.importModal.changeTab = true;
      // this.$refs.importModal.startTask()
    },
    // 导入
    importModal() {
      this.$refs.importModal.open({
        template: '/buz/policyAbnormal/exportTemplate',
        upload: '/buz/policyAbnormal/importAbnormal',
        apiPermissionCode: 'order_30_3'
      });
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.orgId = data.id;
        this.searchParams.groupId = '';
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.orgId = '';
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.orgId = '';
        this.searchParams.groupId = '';
      }
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: `/buz/policy/companyList`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 新增，编辑
    modifyPolicy(flag, row) {
      if (flag == 'add') {
        sessionStorage.reloadPolicyData = '1';
        this.$router.push({
          path: '/orderManage/insuredOrder/addPolicy',
          query: { pageFlag: flag }
        });
      } else if (flag == 'edit') {
        this.openPageTabTags('/orderManage/insuredOrder/editPolicy/' + row.policyNo, {
          pageFlag: 'edit',
          pageName: 'policyManage',
          id: row.id,
          policyNo: row.policyNo,
          type: 'anomaly'
        });
      } else if (flag == 'delete') {
        console.log(row);
        this.$Modal.confirm({
          title: '删除',
          content: '<p>确认删除操作?</p>',
          loading: true,
          onOk: () => {
            this.$http({
              url: `/buz/policyDraft/delete`,
              type: 'GET',
              data: { id: row.id },
              apiPermissionCode: 'order_30_6'
            })
              .then(res => {
                this.searchParams.pageNo = 1;
                this.getInsureList();
                this.$Modal.remove();
                this.$Message.success('删除成功');
              })
              .catch(err => {
                this.$Modal.remove();
              });
          }
        });
      }
    },
    handlerPolicyDetail(row, type) {
      this.$refs['policyDetailRef'].open(row, type);
    },
    // 下载电子保单
    confirmEmail() {
      this.$units.notCloseModal(this);
      // if(this.email)
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.showDownloadAll = false;
          const params = this.initFilterObj();
          const obj = {
            ...this.formValidate,
            ...params
          };
          this.$Spin.show();
          this.$http({
            type: 'POST',
            url: '/buz/policy/downloadAll',
            data: obj
          })
            .then(res => {
              this.$Spin.hide();
              this.$Message.success('文件已发送到您的邮箱');
            })
            .catch(() => {
              this.$Spin.hide();
            });
        }
      });
    },
    toShowDownModal() {
      this.showDownloadAll = true;
      this.$refs.formValidate.resetFields();
    },
    //获取电子保单
    async getPro(item) {
      const res = await this.$http({
        url: '/buz/policy/getDownloadUrl',
        type: 'GET',
        data: {
          policyNo: item.policyNo
        },
        apiPermissionCode: 'order_30_7'
      });
      if (res.data) {
        this.policyNo = res.data;
        const target = this.$refs.policyNoBox;
        this.$nextTick(() => {
          target.click();
        });
      }
    },
    async toggleSecondTab(index, item) {
      this.curActive = index;
      this.searchParams.secondTab = item.value;
      this.searchParams.pageNo = 1;
      if (this.searchParams.secondTab === this.copySecondTab) return;
      this.getInsureList();
    },
    pageChange(pageNo) {
      if (!this.isAll) {
        this.isCheckPage = false;
        this.checkAllGroup = [];
      }
      this.searchParams.pageNo = pageNo;
      this.getInsureList();
    },

    //获取保单列表
    async getInsureList() {
      const params = this.initFilterObj();
      this.copyFirstTab = params.firstTab; //备份
      this.copySecondTab = params.secondTab;
      this.listLoading = true;
      this.$http({
        url: '/buz/policyAbnormal/read/list',
        type: 'POST',
        data: params,
        apiPermissionCode: 'order_30_0'
      })
        .then(res => {
          res.data.forEach(item => {
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
            if (item.policyAdditionalList && item.policyAdditionalList.length > 0) {
              item.hasAdditional = true;
            }
            this.checkItemsList.forEach(item1 => {
              if (item.id == item1.id) {
                item._checked = true;
              }
            });
          });
          // 统计当前页选中的个数
          let checkPageLeng = res.data.filter(item => item._checked).length;
          if (checkPageLeng == res.data.length) {
            this.isCheckPage = true;
          }

          this.total = res.total;
          this.listLoading = false;
          this.insureList = res.data;
        })
        .catch(() => {
          this.listLoading = false;
        });

      this.$http({
        url: '/buz/policyAbnormal/statistics',
        type: 'POST',
        data: params
      }).then(res => {
        this.countObj = res.data;
      });
    },
    getDraftCount() {
      this.$http({
        url: '/buz/policyDraft/read/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 1
        }
      }).then(res => {
        this.draftCount = res.total;
      });
    },
    resetSearch() {
      this.searchParams = {
        date: [],
        userType: '1',
        selectType: '1',
        pageNo: 1,
        pageSize: 5,
        firstTab: this.copyFirstTab,
        secondTab: this.copySecondTab
      };
      this.searchAjax();
    },
    //搜索
    searchAjax() {
      this.searchParams.pageNo = 1;
      this.listLoading = true;
      this.isAll = false;
      this.checkAllGroup = [];
      this.checkItemsList = [];
      this.isCheckPage = false;
      this.getInsureList();
    },
    //获取最新搜索条件
    initFilterObj() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      if (params.date && params.date[0]) {
        params.entryTimeBegin = params.date[0];
        params.entryTimeEnd = params.date[1];
      }
      delete params.selectType;
      delete params.date;
      if (params.userType == 1) {
        //投保人
        params.holderName = params.name;
      } else if (params.userType == 2) {
        //被保险人
        params.insuranceName = params.name;
      }
      delete params.userType;
      delete params.name;
      delete params.applyOrgId;
      return params;
    },
    getList() {
      this.getInsureList();
      this.getDraftCount();
      this.getSysUserList();
      this.getCompanyList();
    },
    // 选中所有
    handleCheckAll() {
      this.isCheckPage = this.isAll;
      const insureList = JSON.parse(JSON.stringify(this.insureList));
      insureList.forEach(item => {
        item._disabled = this.isAll;
        item._checked = this.isAll;
      });
      this.insureList = insureList;
      this.checkAllGroup = [];
      this.checkItemsList = [];
    },
    // 选中当前页
    handleCheckPage() {
      this.isAll = false;
      if (this.isCheckPage) {
        const arr = this.insureList.filter(item => item.id);
        this.checkAllGroup = arr.map(item => item.id);
        this.insureList.forEach(item => {
          item._checked = true;
        });
        // 获取所有已选的id
        let checkedIds = this.checkItemsList.map(item => item.id);
        // 循环当前页列表，去掉之前已选的数据，把未选的数据添加到选中数组中
        this.insureList.map(item => {
          if (!checkedIds.includes(item.id)) {
            this.checkItemsList.push(item);
          }
        });
      } else {
        this.checkAllGroup = [];
        this.insureList.forEach(item => {
          item._checked = false;
        });

        // 获取当前页id集合，并从已选数组中删除掉
        let tableListIds = this.insureList.map(item => item.id);
        this.checkItemsList = this.checkItemsList.filter(item => !tableListIds.includes(item.id));
      }
    },
    // 选中当前
    handleCheckItem(value, item) {
      if (value) {
        this.checkAllGroup.push(item.id);
        // 把当前已选中的数据存放到数组中
        this.checkItemsList.push(item);

        // 获取当前页选中的个数
        let len = this.insureList.filter(item => item._checked).length;
        if (len == this.insureList.length) {
          this.isCheckPage = true;
        }
      } else {
        // 当前页选中数据不等于分页条页，去掉当前页选中
        this.checkAllGroup = this.checkAllGroup.filter(data => data != item.id);
        if (this.checkAllGroup.length != this.insureList.length) {
          this.isCheckPage = false;
        }
        // 从已选中删除掉当前去掉选中的数据
        this.checkItemsList = this.checkItemsList.filter(data => data.id != item.id);
      }
    },
    // 批量删除
    batchDelete() {
      if (this.checkItemsList.length == 0 && !this.isAll) {
        this.$notice.msg('请至少选择一条保单');
        return;
      }
      let ids = this.checkItemsList.map(item => item.id);
      this.$notice.inquiry('确认删除选中保单?').then(() => {
        this.listLoading = true;
        this.$http({
          url: '/buz/policyAbnormal/delBatch',
          type: 'POST',
          data: {
            ...this.initFilterObj(),
            isAll: this.isAll ? 1 : 0,
            ids: this.isAll ? [] : ids
          }
        })
          .then(res => {
            this.searchAjax();
            this.$notice.success(`您已成功删除${res.data}条保单`);
          })
          .finally(e => {
            this.listLoading = false;
          });
      });
    }
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.policy {
  white-space: nowrap;

  &:hover {
    cursor: pointer;
  }
}

.items {
  margin-bottom: 15px;
}

.verifyBox {
  background: #fff0ea;
  border: 1px solid #ffd8c7;
  padding: 4px;
  color: #ff7134;
  font-size: 12px;
  border-radius: 15px 15px 15px 0px;
  position: absolute;
  top: -12px;
  right: -63px;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}

/deep/ .formGroup {
  position: relative;

  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }

  padding: 0;

  .title {
    font-size: 13px;
    font-weight: bold;
    color: #3c464f;
  }
}

/deep/ .formGroup:after {
  display: none;
}

/deep/ .formGroup .title {
  font-size: 13px;
  color: #272933;
  margin-bottom: 0 !important;
  border-bottom: none !important;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}

/deep/ .formGroup {
  height: unset !important;
  position: relative;
  padding: 0;

  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }

  .title {
    font-size: 14px;
    font-weight: bold;
    color: #3c464f;
  }
}

.actionStyle {
  color: #236dff;
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  white-space: nowrap;
}

.my-modal /deep/ .title {
  width: 100%;
  padding-bottom: 10px;
  padding-top: 10px;
  font-size: 14px;
  color: #3c464f;
  font-weight: bold;
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  height: 20px;

  &::before {
    content: '';
    display: block;
    width: 3px;
    height: 14px;
    background-color: #236dff;
    margin-right: 6px;
  }

  &::after {
    content: '';
    display: block;
    background-color: #eff3fc;
    height: 1px;
    width: 100%;
    margin-left: 10px;
  }
}

@import './anomalyOrder.scss';
</style>
